import { type FloorGameCrypto, type NftAsset, type NftCommon } from '@pkg/types/app/floorGame';

// TODO: Can this directly use `NftStatus`?
export enum NftCardNotificationEvent {
    Listed = 'listed',
    Sold = 'sold',
    // `Burned` is temporary until we have a better
    // understanding of how we track "burns".
    Burned = 'burned',
}

export enum NftCardNotificationSuffix {
    Curse = 'curse',
    Explode = 'explode',
}

export interface NftCardNoticeDescriptor {
    id: string;
    event: NftCardNotificationEvent;
    name: NftCommon['name'];
    thumbnail: NftAsset['imageUrl'];
    currency?: FloorGameCrypto;
    price?: number;
}

export type NftCardNotices = NftCardNoticeDescriptor[];
